var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:[
    _vm.fullWidth ? 'full' : null,
    _vm.flexClass,
    _vm.flexJustify ? 'full' : null,
    _vm.flexJustifyClass,
    _vm.flexWrapClass
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }